import { useEffect, useState } from 'react';
import Intercom from '@intercom/messenger-js-sdk';

export const useIntercom = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) return;

    // Visitor mode — tagged as developer inquiry
    Intercom({
      app_id: 'ymve6uz7',
      source: 'remote-assistant.io',
      inquiry_type: 'developer',
    });
    setInitialized(true);

    return () => {
      if (window.Intercom && initialized) {
        window.Intercom('shutdown');
        setInitialized(false);
      }
    };
  }, [initialized]);
};
